import { render, staticRenderFns } from "./chat_moderator.vue?vue&type=template&id=e9dae5fe&scoped=true&"
import script from "./chat_moderator.vue?vue&type=script&lang=js&"
export * from "./chat_moderator.vue?vue&type=script&lang=js&"
import style0 from "./chat_moderator.vue?vue&type=style&index=0&lang=css&"
import style1 from "./chat_moderator.vue?vue&type=style&index=1&id=e9dae5fe&scoped=true&lang=css&"
import style2 from "./chat_moderator.vue?vue&type=style&index=2&id=e9dae5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dae5fe",
  null
  
)

export default component.exports